let configCache = null;

export const loadConfig = async () => {
    if (configCache) return configCache;

    const response = await fetch('/config.json');
    if (!response.ok) {
        throw new Error('No se pudo cargar config.json');
    }

    const config = await response.json();
    configCache = config;
    return config;
};